var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoppingBag3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5556 13.6327C13.5556 14.5244 12.8591 15.2472 12 15.2472C11.1409 15.2472 10.4444 14.5244 10.4444 13.6327C10.4444 12.741 11.1409 12.0182 12 12.0182C12.8591 12.0182 13.5556 12.741 13.5556 13.6327Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 5.8C8.25 3.70132 9.92893 2 12 2C14.0711 2 15.75 3.70132 15.75 5.8V6.81333H17.9299C19.1765 6.81333 20.1402 7.8844 19.9832 9.0953L18.669 19.2286C18.5377 20.2411 17.6581 21 16.6158 21H7.38425C6.34194 21 5.46225 20.2411 5.33095 19.2286L4.0168 9.0953C3.85977 7.8844 4.82351 6.81333 6.0701 6.81333H8.25V5.8ZM12 3.52C10.7574 3.52 9.75 4.54079 9.75 5.8V6.81333H14.25V5.8C14.25 4.54079 13.2426 3.52 12 3.52ZM12 10C10.067 10 8.5 11.6063 8.5 13.5879C8.5 15.7318 10.4721 17.282 11.6967 17.9247C11.8881 18.0251 12.1119 18.0251 12.3033 17.9247C13.5279 17.282 15.5 15.7318 15.5 13.5879C15.5 11.6063 13.933 10 12 10Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag3);
export default __webpack_public_path__ + "static/media/shopping-bag-3.e06f4834b89f79115a596e51d047c0fe.svg";
export { ForwardRef as ReactComponent };